export default __webpack_public_path__ + "static/media/grey-right.0e18d69a.svg";